import styles from './RouteLoading.module.css';

/**
 * `Suspense` fallback for a lazy-loaded route (Phase 10 §18 code splitting).
 *
 * Shown only while a route's own chunk is still being fetched — instant
 * from precache on every repeat visit, so in practice this is seen at most
 * once per route per app lifetime, not on every navigation. Rendered inside
 * `AppShell`'s `<main>`, so it fills the content area, not the full
 * viewport — the tab bar and shell chrome stay visible underneath it.
 * Plain text, matching the app's existing `role="status"` loading
 * convention (`CatalogueCard`'s "Seeding…", `ExercisePickerDialog`'s
 * "Searching…") rather than introducing a new spinner/animation.
 */
export function RouteLoading(): React.JSX.Element {
  return (
    <div className={styles.loading} role="status">
      Loading…
    </div>
  );
}
